import React from 'react';
import PropTypes from 'prop-types';

import { isStrategicAccount } from './Optimizely.helpers';

export class Optimizely extends React.Component {
  hasInitialized = false;

  static propTypes = {
    setAvailable: PropTypes.func.isRequired,
    user: PropTypes.shape({
      venuesList: PropTypes.arrayOf(
        PropTypes.shape({
          orgId: PropTypes.number,
        })
      ),
    }).isRequired,
  };

  componentDidMount() {
    const { setAvailable, user } = this.props;

    if (!this.hasInitialized) {
      this.hasInitialized = true;

      // Ensure a "push" interface
      window.optimizely = window.optimizely || [];

      // Optimizely might take awhile to load.  We want to know when it finishes
      window.optimizely.push({
        type: 'addListener',
        filter: { type: 'lifecycle', name: 'initialized' },
        handler: setAvailable(),
      });

      // Checks if at least one of the user's venues belong to a strategic account.
      window.optimizely.push({
        type: 'user',
        attributes: {
          isStrategicAccount: `${isStrategicAccount(user.venuesList)}`,
        },
      });

      // Optimizely may have loaded before the listener was in place to fire
      if (!Array.isArray(window.optimizely)) {
        setAvailable();
      }

      // Check eligibility for experiments on each page change
      document.body.addEventListener('historyChanged', () => window.optimizely.push({ type: 'activate' }));
    }
  }

  render() {
    return null;
  }
}
